export const AwarenessEventSetType = 'awarenessEventSet';